module.exports = __webpack_public_path__ + "img/img-13.3ab21887.svg";